import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { industries } from "@/lib/data";
import { ArrowUpRight } from "lucide-react";

export default function IndustriesPanels() {
    return (
        <section data-testid="industries" className="border-t border-line bg-bg-alt">
            <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-20 md:py-32">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
                    <div>
                        <p className="eyebrow mb-6">Industries we specialize in</p>
                        <h2 className="font-display text-4xl md:text-6xl tracking-tight leading-[0.95] max-w-2xl">Different rooms. Different rules.</h2>
                        <p className="text-muted max-w-lg mt-4 text-sm md:text-base leading-relaxed">Every scope is shaped by how your business actually runs — clinic workflows, restaurant service, hotel operating hours, retail traffic.</p>
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {industries.map((ind, i) => (
                        <motion.div
                            key={ind.slug}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
                            className="relative group"
                        >
                            <Link to={`/industries/${ind.slug}`} className="block relative overflow-hidden bg-ink aspect-[4/5]">
                                <img src={ind.image} alt={`${ind.title} interior in Metro Vancouver`} loading="lazy"
                                     className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-[1.03] transition-[transform,opacity] duration-700" />
                                <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/25 to-transparent" />
                                <div className="relative h-full flex flex-col justify-between p-6 md:p-8 text-bg">
                                    <div className="flex items-center justify-between">
                                        <span className="tick opacity-80">0{i + 1} / Industry</span>
                                        <ArrowUpRight className="w-5 h-5 opacity-90 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" />
                                    </div>
                                    <div>
                                        <h3 className="font-display text-2xl md:text-3xl tracking-tight mb-3">{ind.title}</h3>
                                        <p className="text-sm text-bg/80 max-w-sm">{ind.blurb}</p>
                                    </div>
                                </div>
                            </Link>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
